import ApiService from '@zola-helpers/client/dist/es/http/api';
import type {
  WThemeGroupFontOptionsView,
  WUpdateWeddingThemeCustomizationRequest,
  WWeddingThemeCustomizationView,
  WWeddingThemeView,
} from '@zola/svc-web-api-ts-client';
import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';
import type { StyledPublicWrapperProps } from 'pages/Public.styles';

import * as ActionType from './types/WeddingThemeActionTypes';
import type { WeddingThemeActionTypes } from './types/WeddingThemeActionTypes';
import type { AppThunk } from '../reducers';

export function receiveWeddingTheme(json: WWeddingThemeView): WeddingThemeActionTypes {
  return {
    type: ActionType.RECEIVE_WEDDING_THEME,
    payload: {
      theme: json,
    },
  };
}

function receiveCustomizationValues(json: WWeddingThemeCustomizationView): WeddingThemeActionTypes {
  return {
    type: ActionType.RECEIVE_CUSTOMIZATION_VALUES,
    payload: {
      customization: json,
    },
  };
}

export function getDashboardTheme(weddingAccountId = ''): AppThunk<Promise<void>> {
  return (dispatch): Promise<void> => {
    return ApiService.get<WWeddingThemeView>(`/web-api/v1/weddingTheme/${weddingAccountId}`).then(
      (response: WWeddingThemeView) => {
        dispatch(receiveWeddingTheme(response));
      }
    );
  };
}

export function customizeTheme(
  customizationValues: WUpdateWeddingThemeCustomizationRequest
): AppThunk<Promise<void>> {
  return (dispatch): Promise<void> => {
    return ApiService.put<WWeddingThemeCustomizationView>(
      '/web-api/v1/weddingTheme/customize',
      customizationValues
    ).then((response: WWeddingThemeCustomizationView) => {
      dispatch(receiveCustomizationValues(response));
      dispatch(
        toastsActions.positive({
          headline: 'Changes saved',
        })
      );
    });
  };
}

function receiveFonts(json: WThemeGroupFontOptionsView): WeddingThemeActionTypes {
  return {
    type: ActionType.RECEIVE_THEME_FONTS,
    payload: {
      themeFonts: json,
    },
  };
}

export function getFontsList(themeKey: string): AppThunk<Promise<void>> {
  return (dispatch): Promise<void> => {
    return ApiService.get<WThemeGroupFontOptionsView>(`/web-api/v3/theme/${themeKey}/fonts`).then(
      (response: WThemeGroupFontOptionsView) => {
        dispatch(receiveFonts(response));
      }
    );
  };
}

export function receiveCustomizationDraft(
  draft: StyledPublicWrapperProps
): WeddingThemeActionTypes {
  return {
    type: ActionType.RECEIVE_CUSTOMIZATION_DRAFT,
    payload: {
      customizationDraft: draft,
    },
  };
}

export function clearCustomizationDraft(): WeddingThemeActionTypes {
  return {
    type: ActionType.RECEIVE_CLEAR_CUSTOMIZATION_DRAFT,
  };
}

export function deleteThemeCustomization(uuid: string): AppThunk<Promise<void>> {
  return (dispatch): Promise<void> => {
    return ApiService.delete<WWeddingThemeCustomizationView>(
      `/web-api/v1/weddingTheme/delete/${uuid}`
    ).then((response: WWeddingThemeCustomizationView) => {
      dispatch(receiveCustomizationValues(response));
      dispatch(
        toastsActions.positive({
          headline: 'Reset to default palette',
        })
      );
    });
  };
}
